import get from 'lodash/get';
import { createSelector } from 'reselect';
import { makeSelectorFactory } from '../../utils/redux/selectAdapter';

export const selectCirclesState = state => get(state, 'circles');
const getSelectors = makeSelectorFactory(selectCirclesState);

export const removeProviderSelector = state =>
  state.circles.removeAssignedProvider;
export const acceptInviteToFamilyCircleSelector = state =>
  state.circles.acceptInviteToFamilyCircle;
export const acceptCaregiverRoleSelector = state =>
  state.circles.acceptCaregiverRole;
export const acceptGuardianRoleSelector = state =>
  state.circles.acceptGuardianRole;
export const selectGuardianCircle = state =>
  get(state, 'circles.guardianCircle');

export const {
  selectStateList: selectCaregiverCircleList,
  selectStatePending: selectCaregiverCirclePending,
} = getSelectors('caregiver');

export const selectInviteCaregiverFamily = state =>
  get(state, 'circles.inviteCaregiverFamily', {});

//= =================INVITE FAMILY CIRCLE==================

export const selectInviteToFamilyCircle = state =>
  get(state, 'circles.inviteToFamilyCircle', {});

export const selectErrorInviteToFamilyCircle = createSelector(
  selectInviteToFamilyCircle,
  state => get(state, 'error', false),
);

export const selectSucceedInviteToFamilyCircle = createSelector(
  selectInviteToFamilyCircle,
  state => get(state, 'succeed', false),
);

export const selectRejectedInviteToFamilyCircle = createSelector(
  selectInviteToFamilyCircle,
  state => get(state, 'rejected', false),
);

//= =================INVITE CAREGIVER ROLE==================

export const selectInviteCaregiverRole = state =>
  get(state, 'circles.inviteCaregiver', {});

export const selectSucceedInviteCaregiver = createSelector(
  selectInviteCaregiverRole,
  request => get(request, 'succeed', false),
);

export const selectErrorInviteCaregiver = createSelector(
  selectInviteCaregiverRole,
  request => get(request, 'error', false),
);
//= =================INVITE GUARDIAN ROLE===================

export const selectInviteGuardianRole = state =>
  get(state, 'circles.inviteGuardian', {});

export const selectSucceedInviteGuardian = createSelector(
  selectInviteGuardianRole,
  state => get(state, 'succeed', false),
);

export const selectErrorInviteGuardian = createSelector(
  selectInviteGuardianRole,
  state => get(state, 'error', false),
);

//= =================LEAVE FAMILY CIRCLE===================

export const selectLeaveFamilyCircle = state =>
  get(state, 'circles.leaveFamilyCircle', {});

export const selectSucceedLeaveFamilyCircle = createSelector(
  selectLeaveFamilyCircle,
  state => get(state, 'succeed', false),
);

export const selectRejectedLeaveFamilyCircle = createSelector(
  selectLeaveFamilyCircle,
  state => get(state, 'rejected', false),
);

//= =================CHANGE ROLE===================

export const selectChangeMemberRole = state =>
  get(state, 'circles.changeMemberRole', {});

export const selectSucceedChangeMemberRole = createSelector(
  selectChangeMemberRole,
  state => get(state, 'succeed', false),
);

export const selectRejectedChangeMemberRole = createSelector(
  selectChangeMemberRole,
  state => get(state, 'rejected', false),
);

//= ========================================================

export const selectSucceedFamilyCircleReq = createSelector(
  selectSucceedInviteToFamilyCircle,
  selectSucceedLeaveFamilyCircle,
  selectSucceedChangeMemberRole,
  (req, req1, req2) => req || req1 || req2,
);

export const selectRejectedFamilyCircleReq = createSelector(
  selectRejectedInviteToFamilyCircle,
  selectRejectedLeaveFamilyCircle,
  selectRejectedChangeMemberRole,
  (req, req1, req2) => req || req1 || req2,
);

export const selectRemoveGuardianRole = state =>
  get(state, 'circles.removeGuardianRole', {});

export const selectSucceedInviteCaregiverFamily = createSelector(
  selectInviteCaregiverFamily,
  request => get(request, 'succeed', false),
);

export const selectSucceedRemoveGuardian = createSelector(
  selectRemoveGuardianRole,
  request => get(request, 'succeed', false),
);

export const removedContextUserIdSelector = createSelector(
  removeProviderSelector,
  request => get(request, 'removedContextUserId', null),
);

export const sendingInviteToFamilyCircleSelector = createSelector(
  acceptInviteToFamilyCircleSelector,
  request => get(request, 'sending', false),
);

export const sendingInviteToCaregiverRoleSelector = createSelector(
  acceptCaregiverRoleSelector,
  request => get(request, 'sending', false),
);

export const sendingInviteToGuardianRoleSelector = createSelector(
  acceptGuardianRoleSelector,
  request => get(request, 'sending', false),
);

// DECLINE INVITATIONS
export const { selectStatePending: selectDecilentFamilyInvite } = getSelectors(
  'declineInviteToFamilyCircle',
);
export const {
  selectStatePending: selectDecilentCaregiverInvite,
} = getSelectors('declineCaregiverRole');
export const {
  selectStatePending: selectDecilentGuardianInvite,
} = getSelectors('declineGuardianRole');

export const selectFamilyInvitationPending = createSelector(
  selectDecilentFamilyInvite,
  sendingInviteToFamilyCircleSelector,
  (declinePending, acceptPending) => declinePending || acceptPending,
);
export const selectCaregiverInvitationPending = createSelector(
  selectDecilentCaregiverInvite,
  sendingInviteToCaregiverRoleSelector,
  (declinePending, acceptPending) => declinePending || acceptPending,
);
export const selectGuardianInvitationPending = createSelector(
  selectDecilentGuardianInvite,
  sendingInviteToGuardianRoleSelector,
  (declinePending, acceptPending) => declinePending || acceptPending,
);

export const {
  selectStateError: selectCancelFamilyMemberInvitationError,
  selectStateSucceed: selectCancelFamilyMemberInvitationSucceed,
} = getSelectors('cancelFamilyMemberInvitation');

export const {
  selectStateError: selectCancelCaregiverInvitationError,
  selectStateSucceed: selectCancelCaregiverInvitationSucceed,
} = getSelectors('cancelCaregiverInvitation');

export const {
  selectStateError: selectCancelGuardianInvitationError,
  selectStateSucceed: selectCancelFGuardianInvitationSucceed,
} = getSelectors('cancelGuardianInvitation');

export const selectCancelPendingInvitationSucceed = createSelector(
  selectCancelFamilyMemberInvitationSucceed,
  selectCancelCaregiverInvitationSucceed,
  selectCancelFGuardianInvitationSucceed,
  (req, req1, req2) => req || req1 || req2,
);

export const selectCancelPendingInvitationReqError = createSelector(
  selectCancelFamilyMemberInvitationError,
  selectCancelCaregiverInvitationError,
  selectCancelGuardianInvitationError,
  (req, req1, req2) => req || req1 || req2,
);

// TODO
export const {
  selectStatePending: selectProviderCircleListPending,
  selectStateList: selectProviderCircleList,
} = getSelectors('memberProviderCircle');

export const selectCircleLoadingState = createSelector(
  selectInviteGuardianRole,
  selectInviteToFamilyCircle,
  selectInviteCaregiverRole,
  selectChangeMemberRole,
  (...state) => state.some(({ sending }) => Boolean(sending)),
);



// WEBPACK FOOTER //
// ./src/redux/circles/selectors.js